// extracted by mini-css-extract-plugin
export default {"formBlock":"style_formBlock__kYm83","fieldContainer":"style_fieldContainer__ygBmK"};